<template>
  <div
    class="judge_box"
    v-loading="loading"
    :element-loading-text="this.$config.loadingText"
    :element-loading-spinner="this.$config.loadingSpinner"
    :element-loading-background="this.$config.loadingBackground"
  >
    <div class="judge_head">
      <a @click="goBackVoteList()"><i class="el-icon-s-fold"></i></a>
      <span>登录人：{{ judgeUserInfo.UserDisplayName }}</span>
      <a @click="refreshScreenFlow()"><i class="el-icon-refresh"></i></a>
    </div>
    <div class="judge_body" :style="bodyStyle">
      <div v-if="screenFlow.StepId === '1'">
        暂无开始项目，请等待主持人开启评分
      </div>
      <div class="judge_project" v-if="screenFlow.StepId != '1'">
        <div class="ranking_main" v-if="screenFlow.StepId === '5'">
          <div
            v-for="(item, index) in groupRankingInfo.ScreenVoteGroupRankingList"
            :key="index"
          >
            <div class="ranking_title">
              <div
                class="ranking_title_index"
                v-show="index < groupRankingInfo.VoteScreenRankingNum"
              >
                第{{ item.RankNum }}名：
              </div>
              <div>
                {{ item.ProjectName }}
              </div>
            </div>
            <div class="ranking_remark">
              {{ item.ProjectRemark }}
            </div>
            <div class="ranking_score">
              <div v-if="item.ProjectTotalScore">
                最终得分：<span>{{ item.TotalScore }}</span> 分
              </div>
              <div v-if="!item.ProjectTotalScore">最终得分：未打分</div>
            </div>
          </div>
        </div>
        <div class="ranking_main" v-if="screenFlow.StepId === '6'">
          <div
            v-for="(item, index) in groupRankingInfo.ScreenVoteGroupRankingList"
            :key="index"
          >
            <div class="ranking_title">
              <div
                class="ranking_title_index"
                v-show="index < groupRankingInfo.VoteScreenRankingNum"
              >
                第{{ item.RankNum }}名：
              </div>
              <div>
                {{ item.ProjectName }}
              </div>
            </div>
            <div class="ranking_remark">
              {{ item.ProjectRemark }}
            </div>
            <div class="ranking_score">
              <div class="score" v-if="item.TotalScore">
                最终得分：<span>{{ item.TotalScore }}</span> 分
              </div>
              <div class="score" v-if="!item.TotalScore">最终得分：未打分</div>
            </div>
          </div>
        </div>
        <div
          class="judge_project_name"
          v-if="screenFlow.StepId !== '5' && screenFlow.StepId !== '6'"
        >
          <span style="text-align: left">
            {{ judgeVoteProjectInfo.ProjectName }}
          </span>
          <p v-if="screenFlow.StepId === '3' && screenFlow.IsBegin === 0">
            （已经结束投票）
          </p>
          <p v-if="screenFlow.StepId === '4'">
            得分：{{ judgeVoteProjectInfo.TotalScore }} 分
          </p>
        </div>
        <div
          class="judge_project_bar"
          v-if="screenFlow.StepId === '3' && screenFlow.IsBegin === 1"
        >
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            label-position="left"
            class="demo-ruleForm"
          >
            <el-form-item
              label="分 数："
              prop="projectScore"
              v-show="!judgeVoteProjectInfo.IsDetailRule"
            >
              <el-col :xs="17" :sm="17" :md="17" :lg="17" :xl="17">
                <el-input-number
                  size="mini"
                  class="number"
                  :controls="false"
                  v-model="ruleForm.projectScore"
                  :precision="judgeVoteProjectInfo.ScoringDecimalPlaces"
                ></el-input-number>
              </el-col>
              <el-col :offset="1" :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-button
                  type="primary"
                  style="width: 100%"
                  @click="submitForm('ruleForm')"
                >
                  保存
                </el-button>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="form_item_info">
                  请输入
                  {{ judgeVoteProjectInfo.MinScore }}
                  ~
                  {{ judgeVoteProjectInfo.MaxScore }}
                  的分数
                </div>
              </el-col>
            </el-form-item>
            <el-form-item
              label="分 数："
              prop="projectScore"
              v-show="judgeVoteProjectInfo.IsDetailRule"
            >
              <el-col :xs="17" :sm="17" :md="17" :lg="17" :xl="17">
                {{ ruleForm.projectScore }}
              </el-col>
              <el-col :offset="1" :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-button
                  type="primary"
                  style="width: 100%"
                  @click="submitForm('ruleForm')"
                >
                  保存
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item
              label-width="0px"
              prop="projectScore"
              v-for="(
                projectRuleItem, projectRuleItemIndex
              ) in judgeVoteProjectInfo.ProjectRuleItems"
              :key="projectRuleItemIndex"
            >
              <div class="mobile_project_box">
                <div class="project_item">
                  <div class="content">
                    {{ projectRuleItemIndex + 1 }}.{{
                      projectRuleItem.ProjectRuleItemTitle
                    }}
                  </div>
                  <a
                    @click="
                      projectRuleItem.IsShowContent =
                        !projectRuleItem.IsShowContent
                    "
                  >
                    <i
                      class="el-icon-caret-bottom icon_right icon_primary"
                      :style="
                        projectRuleItem.IsShowContent
                          ? 'transform: rotate(-180deg);transition: all .5s'
                          : 'transform: rotate(0deg);transition: all .5s'
                      "
                    ></i>
                  </a>
                  <div class="rule_detaile_score">
                    <el-input-number
                      size="mini"
                      class="number"
                      :controls="false"
                      placeholder="打分"
                      :precision="judgeVoteProjectInfo.ScoringDecimalPlaces"
                      :min="projectRuleItem.ProjectRuleItemMinScore"
                      :max="projectRuleItem.ProjectRuleItemMaxScore"
                      v-model="projectRuleItem.ProjectRuleItemScore"
                      @focus="projectRuleItemScore_focus(projectRuleItem)"
                      @blur="
                        projectRuleItemScore_blur(
                          judgeVoteProjectInfo,
                          projectRuleItem
                        )
                      "
                    ></el-input-number>
                  </div>
                </div>
                <div
                  class="project_item"
                  v-show="projectRuleItem.IsShowContent"
                >
                  <div class="content">
                    <div v-html="projectRuleItem.ProjectRuleItemContent"></div>
                  </div>
                </div>
                <div class="project_item">
                  <div class="score_range">
                    打分范围：
                    {{ projectRuleItem.ProjectRuleItemMinScore }}
                    ~
                    {{ projectRuleItem.ProjectRuleItemMaxScore }}
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="judge_foot">
      <el-link @click="goBackVoteList">返回投票列表</el-link>
      <!-- <a @click="goBackVoteList">返回投票列表</a> -->
    </div>
  </div>
</template>

<script>
import screenApi from '../../../api/mobileVote/screen'
import 'signalr'
export default {
  data () {
    var validateScore = (rule, value, callback) => {
      if (value < 0 || value > 100) {
        callback(new Error('输入无效，得分为0-100分'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      judgeUserInfo: {},
      judgeVoteProjectInfo: {},
      judgeProjectScore: {},
      screenFlow: {},
      ruleForm: {
        projectScore: ''
      },
      rules: {
        projectScore: [
          { required: true, message: '请输入分数', trigger: 'blur' },
          { validator: validateScore, trigger: 'blur' }
        ]
      },
      bodyStyle: {
        marginTop: '10px'
      },
      groupRankingInfo: {},
      conn: {}
    }
  },
  methods: {
    getScreenFlow: function () {
      this.loading = true
      screenApi.getScreenFlow({
        voteId: this.$route.params.vid
      }).then(data => {
        this.screenFlow = data
        this.screenFlowStepChange()
        this.connectionHub()
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    getJudgeVoteUser: function () {
      screenApi.getJudgeVoteUser().then(data => {
        this.judgeUserInfo = data
      }).catch(err => {
        return err
      })
    },
    getJudgeVoteProject: function () {
      screenApi.getJudgeVoteProject({
        meetingId: this.screenFlow.MeetingId,
        voteId: this.screenFlow.VoteId,
        groupId: this.screenFlow.GroupId,
        projectId: this.screenFlow.ProjectId
      }).then(data => {
        this.judgeVoteProjectInfo = data
      }).catch(err => {
        return err
      })
    },
    getGroupRankingInfo: function () {
      this.loading = false
      screenApi.getGroupRankingInfo({
        meetingId: this.screenFlow.MeetingId,
        voteId: this.screenFlow.VoteId,
        groupId: this.screenFlow.GroupId
      }).then(data => {
        this.groupRankingInfo = data
        this.loading = false
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    getProjectScore: function () {
      screenApi.getProjectScore({
        voteId: this.screenFlow.VoteId,
        projectId: this.screenFlow.ProjectId
      }).then(data => {
        this.ruleForm.projectScore = data
      }).catch(err => {
        return err
      })
    },
    submitForm: function (formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const projectRuleItems = []
          if (this.judgeVoteProjectInfo.IsDetailRule) {
            this.judgeVoteProjectInfo.ProjectRuleItems.forEach(projectRuleItem => {
              projectRuleItems.push({ ProjectRuleItemID: projectRuleItem.ProjectRuleItemID, ProjectRuleItemScore: projectRuleItem.ProjectRuleItemScore })
            })
          }
          screenApi.setProjectScore({
            meetingId: this.screenFlow.MeetingId,
            voteId: this.screenFlow.VoteId,
            projectId: this.screenFlow.ProjectId,
            score: this.ruleForm.projectScore,
            IsDetailRule: this.judgeVoteProjectInfo.IsDetailRule,
            ProjectRuleItems: projectRuleItems
          }).then(data => {
            this.loading = false
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！'
            })
          }).catch(err => {
            this.loading = false
            return err
          })
        }
      })
    },
    screenFlowStepChange: function () {
      // MeetingId    GroupId    VoteId     ProjectId    StepId    IsBegin    IsSendMessage
      switch (this.screenFlow.StepId) {
        case '1':
          // 什么也不做
          break
        case '2':
          this.getJudgeVoteProject()
          break
        case '3':
          this.getJudgeVoteProject()
          if (this.screenFlow.IsBegin === 0) {
            // 什么也不做
          } else {
            this.getProjectScore()
          }
          break
        case '4':
          this.getJudgeVoteProject()
          break
        case '5':
          this.getGroupRankingInfo()
          break
        case '6':
          this.getGroupRankingInfo()
          break
        case '001':
          if (this.screenFlow.VoteType === 0) {
            this.$router.push({ name: 'shortlist', params: { mid: this.$route.params.mid, vid: this.screenFlow.VoteId } })
          }
          if (this.screenFlow.VoteType === 3) {
            if (this.$route.params.vid === this.screenFlow.VoteId) {
              this.conn.stop()
              this.getScreenFlow()
              this.getJudgeVoteUser()
            } else {
              this.$router.push({ name: 'judgeVote', params: { mid: this.$route.params.mid, vid: this.screenFlow.VoteId } })
            }
          }
          break
      }
    },
    connectionHub: function () {
      const _this = this
      const voteId = _this.$route.params.vid
      const state = JSON.parse(window.localStorage.getItem('state'))
      const token = state.token
      const baseUrl = _this.$config.baseSite

      // const conn = window.jQuery.hubConnection(baseUrl + '/signalr', { qs: 'access_token=' + token })
      _this.conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + token })
      const chatHubProxy = _this.conn.createHubProxy('screenFlowHub')

      chatHubProxy.on('addRoom', function () {

      })

      _this.conn.start().done((data) => {
        chatHubProxy.invoke('addRoom', voteId)
          .done((data) => {
            _this.loading = false
            _this.$message({ showClose: true, type: 'success', message: '投票准备就绪' })
          })
          .fail((msg) => {
            _this.loading = false
            _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
          })
      }).fail((msg) => {
        _this.loading = false
        _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
      })

      _this.conn.error((error) => {
        console.log(error)
      })
      // 重新连接
      _this.conn.reconnected(() => {
        // console.log('重新连接')
      })
      // 当连接已断开连接
      _this.conn.disconnected(() => {
        // console.log('当连接已断开连接')
      })
      // 接收消息
      _this.conn.received((data) => {
        if (data.H && data.M && data.A) {
          if (data.H === 'ScreenFlowHub' && data.M === 'sendScreenFlow' && data.A) {
            _this.screenFlow = JSON.parse(data.A[0])
            // alert(_this.screenFlow.IsAdmin)
            _this.screenFlowStepChange()
          }
        }
      })

      // 当客户端检测到慢速或频繁删除连接时引发
      _this.conn.connectionSlow(() => {
        // console.log('当客户端检测到慢速或频繁删除连接时引发')
      })
    },
    goBackVoteList: function () {
      this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
    },
    refreshScreenFlow: function () {
      this.getScreenFlow()
    },
    projectRuleItemScore_focus: function (item) {
      item.ProjectRuleItemScore_temp = parseFloat(item.ProjectRuleItemScore)
      item.ProjectRuleItemScore = undefined
    },
    projectRuleItemScore_blur: function (currentProject, item) {
      if (!item.ProjectRuleItemScore) {
        item.ProjectRuleItemScore = parseFloat(item.ProjectRuleItemScore_temp)
      }
      currentProject.Score = 0
      this.ruleForm.projectScore = 0
      currentProject.ProjectRuleItems.forEach(ruleItem => {
        if (ruleItem.ProjectRuleItemScore) {
          //   currentProject.Score += Math.round((ruleItem.ProjectRuleItemScore * ruleItem.ProjectRuleItemScorePercent) * 100) / 100
          currentProject.Score += ruleItem.ProjectRuleItemScore * ruleItem.ProjectRuleItemScorePercent
        }
      })
      this.ruleForm.projectScore = currentProject.Score
    }
  },
  mounted () {
    this.getScreenFlow()
    this.getJudgeVoteUser()
  },
  beforeDestroy () {
    this.conn.stop()
  },
  watch: {
    $route () {
      this.getScreenFlow()
      this.getJudgeVoteUser()
    }
  }
}
</script>

<style lang="less">
@import '../../../assets/css/mobileVote/vote.css';
</style>
